"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WmsLayerGroup = void 0;
var strongly_typed_events_1 = require("strongly-typed-events");
var WmsLayerGroup = /** @class */ (function () {
    function WmsLayerGroup(_layerType, _layerSubType, _displayName, _ref, _url) {
        var _this = this;
        this._layerType = _layerType;
        this._layerSubType = _layerSubType;
        this._displayName = _displayName;
        this._ref = _ref;
        this._url = _url;
        //event - LayerGroupLoading
        this._onLayerGroupLoading = new strongly_typed_events_1.SimpleEventDispatcher();
        //event - LayerGroupLoaded
        this._onLayerGroupLoaded = new strongly_typed_events_1.SimpleEventDispatcher();
        this.isVisible = function (store) {
            return store.isLayerVisibile(_this._ref, _this.visibleOnFirstLoad);
        };
        /**
        * Returns false if the layer group is turned on and at least one child layer is enabled, i.e. within zoom limits
        * @param store This is the MapStore
        * @param mapZoom This is the zoom level of the map
        * @returns returns a string version of bar
        */
        this.isDisabled = function (store, mapZoom) {
            if (!store.isLayerVisibile(_this._ref, _this.visibleOnFirstLoad)) {
                //is the layer even turned on?
                return false;
            }
            //are all the child layers within zoom bounds?
            for (var _i = 0, _a = _this.layers; _i < _a.length; _i++) {
                var lyr = _a[_i];
                if (lyr.visible === true) {
                    return false;
                }
            }
            return true;
        };
        this.setLayersVisibility = function (mapZoom, store) {
            for (var _i = 0, _a = _this.layers; _i < _a.length; _i++) {
                var lyr = _a[_i];
                lyr.setVisibility(mapZoom, store);
            }
        };
        this.reLoadLayers = function () {
            //not in use at the moment
            //this._loadingCount = 0;
            //this.layers.forEach((layer) => {
            //    layer.wmsLayer.olWmsLayer.changed();
            //});
        };
        this.addLayerHandlers = function () {
            _this.layers.forEach(function (layer) {
                layer.onLayerLoading.subscribe(_this.onWmsLayerLoading);
                layer.onLayerLoaded.subscribe(_this.onWmsLayerLoaded);
            });
        };
        this.onWmsLayerLoading = function (args) {
            if (_this._loadingCount === 0) {
                _this._onLayerGroupLoading.dispatch({
                    layerGroup: _this
                });
            }
            _this._loadingCount += 1;
        };
        this.onWmsLayerLoaded = function (args) {
            var self = _this;
            self._loadingCount -= 1;
            if (self._loadingCount === 0) {
                //all done
                self._onLayerGroupLoaded.dispatch({
                    layerGroup: self
                });
            }
        };
        this.displayInLayerSwitcher = true;
        this.displayInLegend = true;
        this.visibleOnFirstLoad = true;
        this.visibleOnLoad = false;
        this.info_format = "application/vnd.ogc.gml";
        this.info_columns_to_show = new Array();
        this.layers = new Array();
        this._loadingCount = 0;
        this.addLayerHandlers();
    }
    Object.defineProperty(WmsLayerGroup.prototype, "onLayerGroupLoading", {
        get: function () {
            return this._onLayerGroupLoading.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WmsLayerGroup.prototype, "onLayerGroupLoaded", {
        get: function () {
            return this._onLayerGroupLoaded.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WmsLayerGroup.prototype, "layerType", {
        get: function () {
            return this._layerType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WmsLayerGroup.prototype, "ref", {
        get: function () {
            return this._ref;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WmsLayerGroup.prototype, "displayName", {
        get: function () {
            return this._displayName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WmsLayerGroup.prototype, "url", {
        get: function () {
            return this._url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WmsLayerGroup.prototype, "layerSubType", {
        get: function () {
            return (this._layerSubType);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WmsLayerGroup.prototype, "queryableLayers", {
        get: function () {
            var queryLayers = new Array();
            if (this.queryable) {
                queryLayers = this.layers.filter(function (f) { return f.olWmsLayer.getVisible(); });
            }
            return queryLayers;
        },
        enumerable: false,
        configurable: true
    });
    return WmsLayerGroup;
}());
exports.WmsLayerGroup = WmsLayerGroup;
//# sourceMappingURL=WmsLayerGroup.js.map